import React from 'react';

export function FilterButton({
  active = false,
  children,
  onClick
}: {
  active?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
}) {
  return (
    <button
      type="button"
      className={`inline-flex h-14 items-center justify-center rounded-lg border px-8 text-xl font-gilroy-medium shadow-sm transition focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 ${
        active
          ? 'border-primary-600 bg-primary-600 text-white hover:brightness-95'
          : 'border-gray-200 bg-white text-neutral-700 hover:bg-gray-50'
      }`}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
